import { render, staticRenderFns } from "./SMAllRequests.vue?vue&type=template&id=27d4b756&"
import script from "./SMAllRequests.vue?vue&type=script&lang=js&"
export * from "./SMAllRequests.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports